/**
 * Focus directive
 * https://blog.thecodecampus.de/angular-2-set-focus-element/
 *
 * @param {event} focus
 * @deprecated use
 */

import _find from 'lodash-es/find';
import _includes from 'lodash-es/includes';
import { Directive, Input, AfterViewInit, EventEmitter, ElementRef, Inject, Renderer2 } from '@angular/core';

@Directive({
    selector: '[focusMe]'
})
export class FocusMeDirective implements AfterViewInit {
    @Input('focusMe')
    private focusEvent: EventEmitter<boolean>;

    constructor(
        @Inject(ElementRef) private readonly element: ElementRef,
        private readonly renderer: Renderer2
    ) {}

    public ngAfterViewInit(): void {
        this.focusEvent.subscribe((event: Event) => {
            let renderElement: any;
            switch (this.element.nativeElement.localName) {
                case 'p-dropdown' :
                    renderElement = this.element.nativeElement.childNodes[1].childNodes[3].childNodes[1];
                    break;
                case 'div': //ngFor loop case, like p-checkbox
                    renderElement = this.element.nativeElement.children[0].children[0].children[0].children[0].children[0];
                    break;
                case 'p-multiselectfb': //ngFor loop case, like p-checkbox
                    const ul = this.element.nativeElement.children[0].children[1].children[0];
                    const liContainer = _find(ul.children, (li)=> _includes(li.classList, "text"));
                    renderElement = liContainer.children[0];
                    break;
                case 'p-autocompletefb':
                    renderElement = this.element.nativeElement.children[0].children[0];
                    break;
                default :
                    renderElement = this.element.nativeElement.childNodes[0].childNodes[3];
                    break;
            }
            if(renderElement && typeof renderElement.focus !== 'undefined'){
                renderElement
                    .focus()
                    .apply(renderElement, []);
            }



        });

    }
}
